import { Api } from '@/interface/api';

/**
 * 办赛
 */
const aboutCompanySubmit: Api = {
    url: '/api/project/proxy-token/api/users/companySubmit',
    method: 'post',
};

export {
    aboutCompanySubmit,
};
